export const checkoutUrl = 'https://padel-coach-ready.impultienda.ar/checkout'

export const productImage =
  'https://cdn.magicpatterns.com/uploads/uAm5sQr622AGhLAHdF24m6/ChatGPT-Image-11-ago-2026_-08_39_43-p.m..webp'

export const supportEmail = 'kitonline27@gmail.com'

export interface PainPoint {
  emoji: string
  title: string
  paragraphs: string[]
  bullets?: string[]
}

export const painPoints: PainPoint[] = [
  {
    emoji: '😰',
    title: 'Préparer chaque entraînement prend énormément de temps',
    paragraphs: [
      'Avant chaque séance, vous devez sélectionner les bons exercices, construire une progression cohérente, adapter les contenus au niveau de vos joueurs, prévoir les situations tactiques et structurer tout votre entraînement.',
      'Résultat : vous passez parfois presque autant de temps à préparer vos séances qu\u2019à les diriger.',
    ],
  },
  {
    emoji: '⚠️',
    title: 'Il n\u2019est pas toujours facile de savoir quoi proposer ensuite',
    paragraphs: [
      'Chaque joueur évolue à son propre rythme. Chaque paire possède des besoins différents. Vous vous posez régulièrement les mêmes questions :',
    ],
    bullets: [
      'Quel exercice proposer aujourd\u2019hui ?',
      'Comment faire progresser cette paire ?',
      'Comment adapter les contenus selon les niveaux ?',
      'Comment varier les séances sans perdre en qualité ?',
    ],
  },
  {
    emoji: '📚',
    title: 'Vos ressources sont dispersées partout',
    paragraphs: [
      'Exercices. Séances. Programmes. Notes personnelles. Formations. Vidéos. Documents.',
      'Toutes ces ressources existent... mais elles sont réparties dans plusieurs dossiers, plateformes ou supports.',
      'Au lieu d\u2019avoir un seul système organisé, vous perdez du temps à rechercher ce dont vous avez besoin avant chaque entraînement.',
    ],
  },
  {
    emoji: '😩',
    title: 'Votre journée ne s\u2019arrête jamais',
    paragraphs: [
      'Les entraînements s\u2019enchaînent. Les planifications doivent être mises à jour. Les progressions doivent être adaptées. Les joueurs doivent être évalués. Les prochaines séances doivent être préparées.',
      'Et une fois votre journée terminée... il faut encore organiser les entraînements des jours suivants.',
      'Vous êtes devenu coach de padel pour accompagner vos joueurs. Pas pour passer vos soirées à préparer chaque séance.',
    ],
  },
]

export interface Module {
  title: string
  intro: string
  items: string[]
  outro: string
}

export const modules: Module[] = [
  {
    title: 'Bibliothèque d\u2019Exercices & Situations de Jeu™',
    intro:
      'Accédez à une bibliothèque complète d\u2019exercices classés par objectif technique, tactique et situation de jeu.',
    items: [
      'Défense',
      'Transition',
      'Jeu au filet',
      'Bandeja et vibora',
      'Sorties de vitre',
      'Contre-attaque',
      'Construction du point',
    ],
    outro:
      'Chaque exercice comprend des objectifs, variantes, progressions et consignes directement applicables.',
  },
  {
    title: 'Séances Prêtes à l\u2019Emploi™',
    intro:
      'Préparez facilement vos entraînements grâce à des séances professionnelles déjà structurées.',
    items: [
      'Échauffements',
      'Blocs techniques',
      'Travail tactique',
      'Situations conditionnées',
      'Progressions',
      'Jeu appliqué',
      'Séances individuelles',
      'Travail en paire',
    ],
    outro: 'Choisissez la séance adaptée au niveau, à l\u2019objectif et au temps disponible.',
  },
  {
    title: 'Progressions Techniques & Tactiques™',
    intro:
      'Construisez facilement des progressions complètes sans devoir créer chaque étape vous-même.',
    items: [
      'Défense avec vitres',
      'Transition défense-attaque',
      'Conquête du filet',
      'Bandeja et vibora',
      'Jeu aérien',
      'Positionnement',
      'Construction tactique',
    ],
    outro: 'Accompagnez chaque joueur avec une progression claire et structurée.',
  },
  {
    title: 'Planification & Programmation d\u2019Entraînement™',
    intro:
      'Organisez efficacement vos semaines et vos cycles grâce à des outils professionnels prêts à utiliser.',
    items: [
      'Planifications hebdomadaires',
      'Cycles d\u2019entraînement',
      'Objectifs techniques',
      'Objectifs tactiques',
      'Organisation par niveau',
      'Séquences de développement',
      'Répartition des contenus',
    ],
    outro: 'Toute votre organisation repose sur une base claire, logique et professionnelle.',
  },
  {
    title: 'Tactique, Match & Prise de Décision™',
    intro:
      'Développez la capacité de vos joueurs à prendre de meilleures décisions en situation réelle.',
    items: [
      'Sélection des coups',
      'Occupation des espaces',
      'Communication',
      'Transitions',
      'Défense organisée',
      'Conquête du filet',
      'Service et retour',
      'Construction du point',
    ],
    outro:
      'Transformez le travail réalisé à l\u2019entraînement en solutions directement applicables en match.',
  },
  {
    title: 'Évaluation, Suivi & Outils du Coach™',
    intro: 'Centralisez toutes vos évaluations dans un seul système professionnel.',
    items: [
      'Fiches individuelles',
      'Suivi technique',
      'Suivi tactique',
      'Objectifs',
      'Priorités',
      'Progression',
      'Observations',
      'Historique des performances',
    ],
    outro: 'Moins d\u2019improvisation. Plus d\u2019organisation.',
  },
]

export interface Bonus {
  label: string
  title: string
  description: string
}

export const bonuses: Bonus[] = [
  {
    label: 'BONUS 1',
    title: 'Corrections Techniques & Solutions du Coach™',
    description:
      'Un guide professionnel permettant d\u2019identifier les erreurs fréquentes, comprendre leurs causes et sélectionner rapidement des corrections, consignes et exercices adaptés aux différents coups et situations rencontrés sur le terrain.',
  },
  {
    label: 'BONUS 2',
    title: 'Adaptateur de Séances & Variantes Instantanées™',
    description:
      'Des solutions prêtes à utiliser pour adapter vos séances selon le nombre de joueurs, les différences de niveau, le temps disponible ou les contraintes rencontrées, avec des variantes permettant de modifier rapidement chaque exercice.',
  },
  {
    label: 'BONUS 3',
    title: 'Pack Préparation Match & Compétition™',
    description:
      'Des outils professionnels pour préparer vos joueurs avant une compétition, analyser les adversaires, construire un plan de match, définir les priorités tactiques et transformer l\u2019analyse post-match en nouveaux objectifs d\u2019entraînement.',
  },
  {
    label: 'BONUS 4',
    title: 'Système de Coaching des Paires™',
    description:
      'Des ressources avancées pour développer la communication, le positionnement, la couverture des espaces, les déplacements coordonnés, les rôles et les automatismes nécessaires pour construire une paire plus organisée et efficace.',
  },
  {
    label: 'BONUS 5',
    title: 'Coach Courtside Toolkit™',
    description:
      'Une boîte à outils regroupant fiches de préparation, checklists, suivi des objectifs, notes rapides, observations et documents pratiques pour disposer de vos ressources essentielles directement sur le terrain.',
  },
]

export interface Benefit {
  emoji: string
  title: string
  paragraphs: string[]
}

export const benefits: Benefit[] = [
  {
    emoji: '⚡',
    title: 'Gagnez des heures de préparation chaque semaine',
    paragraphs: [
      'Ne perdez plus votre temps à construire chaque entraînement depuis zéro.',
      'Ouvrez simplement le système, choisissez les ressources adaptées et commencez immédiatement votre séance.',
    ],
  },
  {
    emoji: '💪',
    title: 'Travaillez avec davantage de confiance',
    paragraphs: [
      'Structurez facilement vos entraînements grâce à des progressions claires, des outils professionnels et des ressources immédiatement exploitables.',
      'Consacrez davantage de temps à vos joueurs et beaucoup moins à la préparation.',
    ],
  },
  {
    emoji: '📈',
    title: 'Organisez des entraînements plus efficaces',
    paragraphs: [
      'Utilisez des séances, des exercices, des progressions et des planifications déjà structurés pour proposer des entraînements variés, cohérents et facilement adaptables selon le niveau de chaque joueur.',
    ],
  },
  {
    emoji: '🗂️',
    title: 'Organisez votre travail comme un véritable professionnel',
    paragraphs: [
      'Toutes vos ressources sont enfin réunies dans un seul système.',
      'Moins de recherches. Moins d\u2019improvisation. Plus d\u2019organisation.',
    ],
  },
]

export interface Testimonial {
  text: string
  author: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    text: 'Je prépare mes séances en 10 minutes au lieu d\u2019une heure. J\u2019ouvre la bibliothèque d\u2019exercices, je choisis le bloc technique et la situation conditionnée, et tout est déjà structuré. Mes joueurs ont remarqué que mes entraînements sont beaucoup plus clairs depuis que j\u2019utilise le système.',
    author: 'Julien Marchand',
    role: 'Coach de padel, 38 ans — Club',
    location: 'Toulouse',
  },
  {
    text: 'Ce qui m\u2019a le plus aidée, ce sont les progressions techniques. Avant, je savais quoi corriger mais pas toujours dans quel ordre avancer. Maintenant chaque joueuse a une progression claire sur la bandeja et les sorties de vitre, et je vois les résultats en match.',
    author: 'Camille Rousseau',
    role: 'Entraîneuse, 34 ans — Académie',
    location: 'Bordeaux',
  },
  {
    text: 'Je donne 25 heures de cours par semaine entre le club et les cours privés. Le module de planification m\u2019a permis d\u2019organiser mes cycles par niveau une bonne fois pour toutes. Je ne passe plus mes dimanches soir à préparer la semaine.',
    author: 'Nicolas Bertrand',
    role: 'Coach indépendant, 45 ans',
    location: 'Lyon',
  },
  {
    text: 'Le Système de Coaching des Paires vaut à lui seul le prix du kit. La communication et la couverture des espaces sont devenues concrètes pour mes joueurs, avec des exercices que je peux lancer immédiatement sur le terrain.',
    author: 'Sébastien Lefèvre',
    role: 'Coach compétition, 41 ans — Centre sportif',
    location: 'Nantes',
  },
  {
    text: 'Les fiches de suivi ont changé ma façon de travailler. J\u2019ai enfin un historique par joueur : objectifs, priorités, observations. Les parents et les joueurs voient la progression noir sur blanc, et moi j\u2019improvise beaucoup moins.',
    author: 'Aurélie Deschamps',
    role: 'Coach de padel, 36 ans — École de padel',
    location: 'Montpellier',
  },
]

export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'S\u2019agit-il d\u2019un produit physique ?',
    answer:
      'Non. PADEL COACH READY™ est un système 100 % numérique au format PDF, accessible immédiatement après votre achat depuis un ordinateur, une tablette ou un smartphone.',
  },
  {
    question: 'Ce système convient-il aux coachs débutants ?',
    answer:
      'Oui. Il peut être utilisé par des coachs débutants, mais il a été conçu avant tout pour les entraîneurs expérimentés souhaitant gagner du temps et disposer de ressources professionnelles immédiatement exploitables.',
  },
  {
    question: 'Puis-je l\u2019utiliser avec différents niveaux de joueurs ?',
    answer:
      'Absolument. Les exercices, progressions, séances et planifications sont facilement adaptables selon le niveau technique, les besoins et les objectifs de chaque joueur ou paire.',
  },
  {
    question: 'Puis-je adapter les contenus à ma façon de travailler ?',
    answer:
      'Bien sûr. Les exercices, les séances, les progressions et les documents sont entièrement personnalisables afin de s\u2019adapter à votre méthode d\u2019entraînement.',
  },
  {
    question: 'Quand vais-je constater les premiers bénéfices ?',
    answer:
      'La plupart des coachs peuvent réduire leur temps de préparation dès les premières semaines et organiser plus facilement leur travail grâce aux ressources déjà structurées.',
  },
  {
    question: 'Comment vais-je recevoir le système après mon achat ?',
    answer:
      'L\u2019accès est immédiat : vous recevez un e-mail avec le lien de téléchargement des 6 modules et des 5 Bonus Premium juste après le paiement. Aucune attente, aucune livraison physique.',
  },
  {
    question: 'Puis-je l\u2019utiliser sur le terrain, depuis mon téléphone ?',
    answer:
      'Oui. Les documents sont pensés pour être consultés depuis un smartphone ou une tablette entre deux séances, et peuvent aussi être imprimés pour être utilisés directement au bord du terrain.',
  },
  {
    question: 'Le système fonctionne-t-il pour les cours collectifs et les cours privés ?',
    answer:
      'Oui. L\u2019Adaptateur de Séances vous permet de modifier chaque exercice selon le nombre de joueurs, les différences de niveau et le temps disponible, aussi bien en cours individuel qu\u2019en groupe ou en paire.',
  },
  {
    question: 'Y a-t-il un abonnement ou des frais récurrents ?',
    answer:
      'Non. Il s\u2019agit d\u2019un paiement unique de 27 €. Vous conservez l\u2019accès aux 6 modules et aux 5 Bonus Premium sans abonnement ni frais cachés.',
  },
  {
    question: 'Et si le système ne me convient pas ?',
    answer:
      'Vous êtes couvert par la garantie satisfait ou remboursé pendant 7 jours. Contactez-nous dans les 7 jours suivant votre achat et nous vous remboursons 100 % de votre commande, sans justification.',
  },
]

export interface Purchase {
  name: string
  location: string
}

export const purchases: Purchase[] = [
  { name: 'Julien M.', location: 'Toulouse, France' },
  { name: 'Camille R.', location: 'Bordeaux, France' },
  { name: 'Nicolas B.', location: 'Lyon, France' },
  { name: 'Sébastien L.', location: 'Nantes, France' },
  { name: 'Aurélie D.', location: 'Montpellier, France' },
  { name: 'Thomas G.', location: 'Marseille, France' },
  { name: 'Élodie P.', location: 'Lille, France' },
  { name: 'Mathieu C.', location: 'Strasbourg, France' },
  { name: 'Laurent F.', location: 'Nice, France' },
  { name: 'Sophie V.', location: 'Rennes, France' },
  { name: 'Antoine D.', location: 'Paris, France' },
  { name: 'Karim B.', location: 'Aix-en-Provence, France' },
]
